import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogoLight } from "@/components/site/Logo";

const inputCls = "w-full rounded-xl border border-[#D8D7CE] bg-white px-4 py-3.5 outline-none focus:border-[#0B14A0] focus:shadow-[0_0_0_4px_rgba(11,20,160,0.12)] transition-[border-color,box-shadow]";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/nyheter" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin/nyheter");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 grid-lines" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0B14A0] mb-8"><ArrowLeft className="w-4 h-4" />Till webbplatsen</Link>
        <div className="rounded-[28px] bg-white border border-[#E3E2DA] p-8 sm:p-10 shadow-[0_40px_80px_-50px_rgba(7,11,46,0.5)]">
          <LogoLight className="h-8" />
          <h1 className="font-display text-3xl font-bold mt-8">Logga in</h1>
          <p className="text-[#3A3F5C] mt-2">Administrera nyheter på redoc.se.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input type="email" required placeholder="E-post" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email-input" />
            <input type="password" required placeholder="Lösenord" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password-input" />
            {error && <p className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} className="w-full inline-flex justify-center items-center gap-2 rounded-full bg-[#0B14A0] text-white py-3.5 font-semibold hover:bg-[#070B2E] transition-colors disabled:opacity-60" data-testid="admin-login-submit-button">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Logga in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
